export class HrPayWtCumulativeKey {
    private static readonly keyPrefix = 'hrPayWtCumulative';
    public static pageHeader = `${HrPayWtCumulativeKey.keyPrefix}.pageHeader`;
    public static wageType = `${HrPayWtCumulativeKey.keyPrefix}.wageType`;
}
